<template>
  <div class="box4-page">
    <div class="inseec-title">学位证书</div>
    <div class="content-box">
      <img src="../../../assets/coursePage/inseec/box4/1.png" alt="" />
      <h4>高含金量硕士学位证书</h4>
      <p>毕业可获得全球认可的硕士学位证书，与出国留学所获得的证书一致。</p>
      <h4>学位证书可多场景使用</h4>
      <p>可用于求职应聘、升职环节、教育背景展示、海外发展等。</p>
      <h4>学位证书可做各项认证</h4>
      <p>可申请海牙等权威三方国际认证，满足自身证书使用场景需求。</p>
    </div>
    <div class="img-box">
      <vue-seamless-scroll
        :data="list1"
        :class-option="classOption"
        class="seamless-warp"
      >
        <img
          class="demo"
          src="../../../assets/coursePage/inseec/box4/2.png"
          alt=""
        />
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
  import vueSeamlessScroll from "vue-seamless-scroll";

  export default {
    name: "",
    components: {
      vueSeamlessScroll,
    },
    data() {
      return {
        list1: ["0", "1", "2", "3"],
      };
    },
    computed: {
      classOption() {
        return {
          direction: 2,
          step: 0.5,
          limitMoveNum: 2,
        };
      },
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .box4-page {
    background: #ffffff;
    padding: 80px 0 0;
    .inseec-title {
      font-weight: 600;
      font-size: 44px;
      color: #012d72;
      line-height: 64px;
      text-align: center;
    }
    .content-box {
      padding-bottom: 48px;
      > img {
        display: block;
        width: 678px;
        margin: 44px auto 42px;
      }
      > h4 {
        padding: 0 40px 8px;
        font-weight: 500;
        font-size: 32px;
        color: #092a52;
        line-height: 48px;
      }
      > p {
        padding: 0 40px;
        font-weight: 400;
        font-size: 28px;
        color: #092a52;
        line-height: 44px;
        margin-bottom: 32px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .img-box {
      background: #f3f5f8;
      padding: 36px 0 48px;
      .demo {
        width: 1256px;
        height: 382px;
        margin-right: 28px;
      }
    }
  }
</style>
